/**
 * Cookie Banner functionality
 * Handles cookie consent banner display and interactions
 */

export function initCookieBanner() {
    // Cookie banner functionality is handled by Alpine.js component
    // in the cookie-banner.blade.php template
    // This file is kept for future JS-only functionality if needed
}

// Expose global function for footer link to reopen banner
window.openCookieSettings = function() {
    // This will be handled by the Alpine.js component
    // If banner is not visible, we need to show it
    const banner = document.querySelector('[x-data*="cookieBanner"]');
    if (banner && banner._x_dataStack && banner._x_dataStack[0]) {
        banner._x_dataStack[0].showBanner = true;
        banner._x_dataStack[0].showConfigPanel = true;
    }
};

